module.exports = __webpack_public_path__ + "img/P150T_weapon_107.a13d383c.png";